import script from "./HomeContent6-social.vue?vue&type=script&setup=true&lang=js"
export * from "./HomeContent6-social.vue?vue&type=script&setup=true&lang=js"

import "./HomeContent6-social.vue?vue&type=style&index=0&id=933a36ce&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-933a36ce"]])

export default __exports__